__webpack_require__.O(0, ["app"], () => {
	__webpack_require__.E("vendors-node_modules_fortawesome_fontawesome-pro_css_brands_min_css-node_modules_fortawesome_-9a47ef");
	__webpack_require__.E("wp-content_themes_socialbrothers_src_scripts_icons_ts");
}, 5);